import { DEFAULT_MAP_ZOOM, MAP_ZOOM_MAX, MAP_ZOOM_MIN } from '../constants';

export const normalizeOriginCoordinates = (origin) => {
    if (!origin || typeof origin !== 'object') return null;

    const latValue =
        typeof origin.lat === 'function' ? origin.lat() : (origin.lat ?? origin.latitude);
    const lngValue =
        typeof origin.lng === 'function' ? origin.lng() : (origin.lng ?? origin.longitude);

    const lat = Number(latValue);
    const lng = Number(lngValue);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

    return { lat, lng };
};

const normalizeMapZoom = (zoom) => {
    const value = Math.round(Number(zoom));
    if (!Number.isFinite(value) || value < MAP_ZOOM_MIN || value > MAP_ZOOM_MAX) return null;
    return value;
};

export const buildPreviewRequest = ({ category, origin, zoom = DEFAULT_MAP_ZOOM }) => {
    const center = normalizeOriginCoordinates(origin);
    const zoomLevel = normalizeMapZoom(zoom);

    return {
        lat: center?.lat ?? null,
        lng: center?.lng ?? null,
        zoom: zoomLevel,
        query: category || '',
    };
};

export const buildPreviewPaginationRequest = ({ pageQueryId }) => ({
    pageQueryId: String(pageQueryId),
});
